import type { Asserts } from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { buSchema } from '@/features/Sparten/bu/schema/inputSchema';

export const inputSchema = buSchema;

export type InputStore = Asserts<typeof inputSchema>;

export const useBuInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'BuInputStore',
);
